import React from 'react';
import { Modal, Typography, Form, Icon, Input, Button } from 'antd';
import { Selection } from '../../common';
import { InputNum, message } from '../../biz';
import { generators, asserts } from '../../../utils';
import { saveRemind } from '../../../service/common';
import './index.less';

const { Title } = Typography;
const { generatorObject } = generators;

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};

export default Form.create()(
  ({
    form,
    visible,
    days = [],
    number = 0,
    defaultMobile,
    selectedValue = {},
    handleHide,
    handleSuccess,
  }) => {
    const { getFieldDecorator, validateFields } = form;
    const handleCancel = () => handleHide();
    const submit = async (data) => {
      const res = await saveRemind(data);
      if (res.success) {
        const result = generatorObject(res.data);
        if (!result.success) {
          message.error(result.message);
          return;
        }
        message.success('设置成功');
        handleHide();
        asserts.isFunction(handleSuccess) && handleSuccess();
      }
    };
    const handleSubmit = () => {
      validateFields((err, values) => {
        if (err) return;
        const { arImitm, arMcu } = selectedValue;
        const { arItemqty } = values;
        const params = {
          ...values,
          arItemqty: arItemqty ? arItemqty : 0.001,
          arImitm,
          arMcu,
          arType: '0',
          arDelStatus: '1',
        };
        submit(params);
      });
    };
    return (
      <Modal
        visible={visible}
        footer={null}
        destroyOnClose={true}
        title={
          <>
            <Title level={4}>有货提醒设置</Title>
            <span>（已有{number}人设置）</span>
          </>
        }
        width={660}
        wrapClassName="remindModal"
        onCancel={handleCancel}
      >
        <Form {...formItemLayout}>
          <Form.Item wrapperCol={{ span: 24 }} className="custom-item">
            <div>
              <Icon type="bell" style={{ fontSize: '16px' }} />
              <span className="emphasize-font-size">提醒方式</span>
              <span>（若该仓库商品有货，您将立即收到提醒，方便您及时购买）</span>
            </div>
          </Form.Item>
          <Form.Item label="①手机号码" className="special-item custom-item">
            {getFieldDecorator('arMobile', {
              initialValue: defaultMobile,
              rules: [
                {
                  required: true,
                  message: '请输入手机号码',
                },
                {
                  pattern: /^[0-9]{11}$/,
                  message: '请输入11位手机号码',
                },
              ],
            })(<Input style={{ width: 200 }} />)}
          </Form.Item>
          <Form.Item className="special-desc-item custom-item" wrapperCol={{ span: 24 }}>
            ②网页版东明快购消息通知
          </Form.Item>
          <Form.Item wrapperCol={{ span: 24 }} className="custom-item">
            <div>
              <Icon type="file-unknown" style={{ fontSize: '16px' }} />
              <span className="emphasize-font-size">商品需求</span>
              <span>
                （为了给您提供更加及时准确的供货服务，我们希望收集并了解您的具体商品需求）
              </span>
            </div>
          </Form.Item>
          <Form.Item label="需求数量" className="special-item custom-item ">
            {getFieldDecorator('arItemqty', {
              initialValue: `${selectedValue.arItemqty}` !== '0.001' ? selectedValue.arItemqty : '',
            })(<InputNum style={{ width: 200 }} suffix="千支" />)}
          </Form.Item>
          <Form.Item label="期望有货时间" className="special-item custom-item">
            {getFieldDecorator('arDay', {
              initialValue: selectedValue.arDay,
            })(
              <Selection
                source={days}
                transfer={{ key: 'code', code: 'code', name: 'desc' }}
                style={{ width: 200 }}
              />,
            )}
          </Form.Item>
          <Form.Item label="备注" className="special-item custom-item" wrapperCol={{ span: 20 }}>
            {getFieldDecorator('arRemark', {
              initialValue: selectedValue.arRemark,
            })(<Input />)}
          </Form.Item>
          <Form.Item wrapperCol={{ span: 12, offset: 11 }} className="custom-item">
            <Button className="btn-info" type="primary" onClick={handleSubmit}>
              提交
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
  },
);
